<template>
  <div class="head_content">
        <div class="left_image">
           <img class="left_image__img" src="@/assets/images/logo.png" alt="" @click="goHome()"/>
        </div>
        <ul>
          <li
            v-for="(item, index) of topicList"
            :key="index"
            :class="{ active: index==curIndex }"
            @click="indexState(item,index)"
          >
            {{ (item.name) }}
          </li>
        </ul>
        <div class="right">
          <div class="right_icon2"
            @mouseenter="changeImage2"
            @mouseleave="resetImage2"
            v-if="!isLogin"
            @click="requestGetGithub()">
            <img :src="currentImageSrc2" class="right_icon2__img" alt="" />
            登录
          </div>

          <div v-else class="right_icon3" @click="isLoginClick = !isLoginClick">
            <img :src="githubInfo.avatar_url" class="right_icon3__img" alt="" />
            <div class="right_icon3__text">{{githubInfo.account}}</div>
          </div>

          <el-popover
            class="popoverDialog"
            v-model="isLoginClick"
            placement="bottom"
            width="160"
            trigger="hover">
            <div class="popoverDialog__text" @click="requestLoginOut()">退出登录</div>
          </el-popover>
        </div>

        <div class="icon" @click="menuShow()" v-if="$route.path == '/tutorialDetail'">
          <i class="el-icon-menu"></i>
        </div>
  </div>
</template>
<script >
import { getGithub } from "@/config/api.js";
import { getCategoryList } from "@/config/api.js";
import { Popover } from 'element-ui'
import Vue from 'vue'

Vue.use(Popover)
export default {
  components: {},
  data() {
    return {
      topicList: [],
      searchValue: "",
      searchFocus: false,
      lang: "",
      language: [
        {
          label: "中文",
          value: "cn",
        },
        {
          label: "英文",
          value: "en",
        },
      ],
      dialogVisible: false,
      isActiveHeadPC: false,
      curIndex:0,

      defaultImageSrc1: require('@/assets/images/head_icon2.png'),
      hoverImageSrc1: require('@/assets/images/head_icon2s.png'),
      currentImageSrc1: require('@/assets/images/head_icon2.png'),

      defaultImageSrc2: require('@/assets/images/head_icon1.png'),
      hoverImageSrc2: require('@/assets/images/head_icon1s.png'),
      currentImageSrc2: require('@/assets/images/head_icon1.png'),

      isLogin: false,
      isLoginClick: false,
      code: "", // 第三方返回code
      githubInfo: {}, // 登录信息
      githubToken: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    indexState: function (item,index) {
      this.curIndex = index;
      if(this.$route.path != '/'){
        this.$router.push({
          path: "/",
          query: { tutorial: this.curIndex}
        });
      }
      else {
        document.getElementById('tutorial'+this.curIndex).scrollIntoView();
      }
    },
    goHome(){
      this.$router.push({
        path: "/",
      });
    },
    showIcon() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 100
      ) {
        this.isActiveHeadPC = false;
      } else {
        this.isActiveHeadPC = true;
      }
    },
    // 总类类别
    requestGetCategoryList() {
      getCategoryList().then((res) => {
        this.topicList = [{"id":0,name:"首页",slug:"index"}];
        if (res.data) {
          res.data.forEach(element => {
            this.$set(this.topicList, this.topicList.length, {"id": element.ID, name:element.Name, slug: element.Slug})
          });
        }
      });
    },
    changeImage1() {
      this.currentImageSrc1 = this.hoverImageSrc1;
    },
    resetImage1() {
      this.currentImageSrc1 = this.defaultImageSrc1;
    },
    changeImage2() {
      this.currentImageSrc2 = this.hoverImageSrc2;
    },
    resetImage2() {
      this.currentImageSrc2 = this.defaultImageSrc2;
    },
    // 请求第三方登录
    requestGetGithub() {
      // 清空github信息
      localStorage.setItem("github", "");
      localStorage.setItem("githubToken", "");

      const url = "https://github.com/login/oauth/authorize?client_id=Ov23lidjz3oAXUfoWIx9&redirect_uri=https://binschool.org/";
      window.location.href = url;
    },
    // 请求登录信息
    requestGetGithubInfo() {
      var that = this;
      getGithub({code: that.code, appType: 'community'}).then((res) => {
        if (res.code == 200200) {
          that.isLogin = true;
          that.githubInfo = res.data.account;
          that.githubToken = res.data.token;

          // 存储github信息
          localStorage.setItem("github", JSON.stringify(that.githubInfo));
          // 存储githubToken信息
          localStorage.setItem("githubToken", that.githubToken);
        }
      });
    },
    // 退出登录
    requestLoginOut() {
      var that = this;
  
      // 清空github信息
      localStorage.setItem("github", "");
      localStorage.setItem("githubToken", "");
      
      that.isLoginClick = false;
      that.isLogin = false;
    },
    // 菜单栏显示
    menuShow() {
      window.globalStore.menuVisible = !window.globalStore.menuVisible;
    },
  },
  mounted() {
    var that = this;
    window.addEventListener("scroll", this.showIcon);

    var queryData = this.$route.query;
    if (queryData.hasOwnProperty("code")) {
      that.code = queryData.code;
      that.requestGetGithubInfo();
    }

    if(localStorage.getItem("github") != "" || localStorage.getItem("github") != null) {
      const savedObject = localStorage.getItem('github');
      if (savedObject) {
        that.githubInfo = JSON.parse(savedObject);
         that.isLogin = true;
      }
    }
    
    that.curIndex = localStorage.getItem('tutorial');
  },
  beforeMount() {
    var that = this;
    that.requestGetCategoryList();
  }
};
</script>

<style lang="scss" scoped>
.head_content {
  width: 92%;
  height: 60px;
  background: rgba(255,255,255,0.3);
  backdrop-filter: blur(20px);
  z-index: 1000;
  padding: 0 4% 0 4%;
  top: 0;

  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;

    .left_image {
      width: 182px;
      height: 60px;
      &__img {
        width: 182px;
        height: 60px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    ul {
      height: 60px;
      width: auto;
      text-align: center;
      line-height: 60px;
      position: relative;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;

      li {
        width: auto;
        min-width: 70px;
        margin: 0 20px 0 20px;
        font-size: 15px;
        height: 60px;
        line-height: 60px;
        border-radius: 2px;
        text-align: center;
        font-family: Arial-BoldMT;
        font-family: ArialMT;
        padding: 0px 10px;
        color: #474747;
        font-weight: 500;
        cursor: pointer;
      }

      li:hover {
        // color: #000000;
        font-weight: bold;
      }

      .active {
        height: 30px;
        line-height: 30px;
        color: #FFFFFF;
        background: #689BFF;
        border-radius: 20px 20px 20px 20px;
      }
    }

    .right {
      width: 126px;
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .right_icon1 {
        display: flex;
        justify-content: center;
        align-items: center;
        &_img {
          width: 25px;
          height: 60px;
          object-fit: contain;
          cursor: pointer;
        }
      }

      .right_icon2 {
        width: auto;
        height: 36px;
        border-radius: 20px 20px 20px 20px;
        border: 2px solid #000000;

        
        font-weight: normal;
        font-size: 14px;
        color: #000000;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
        
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 0 9px 0 9px;

        &__img {
          width: 24px;
          height: 24px;
          object-fit: contain;
          cursor: pointer;
          margin: 0 5px 0 0;
        }
      }

      .right_icon2:hover {
        border: 2px solid #689BFF;
        color: #689BFF;
      }

      .right_icon3 {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 0 0;
        cursor: pointer;

        &__img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          border-radius: 50%;
        }
        &__text {
          width: 80px;
          
          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          margin: 0 0 0 6px;
        }
      }

      .popoverDialog {
        margin: 65px 0 0 -160px;
  
        &__text {
          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          cursor: pointer;
        }

        .el-popover {
          width: 160px;
          height: 170px;
          background: #FFFFFF;
          box-shadow: 0px 14px 16px 0px rgba(0,0,0,0.05);
          border-radius: 8px 8px 8px 8px;
        }
      }
    
    }

    .icon {
      width: 48px;
      height: 60px;

      display: none;
      justify-content: center;
      align-items: center;

      .el-icon-menu {
        width: 36px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
      }
    }
}

@media screen and (max-width: 958px){ 
  .head_content {
    width: 96%;
    height: 60px;
    background: rgba(255,255,255,0.3);
    backdrop-filter: blur(20px);
    z-index: 1000;
    padding: 0 2% 0 2%;
    top: 0;

    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left_image {
      width: 182px;
      height: 60px;
      &__img {
        width: 182px;
        height: 60px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    ul {
      height: 60px;
      width: auto;
      text-align: center;
      line-height: 60px;
      position: relative;
      z-index: 10;
      display: none;
      align-items: center;
      justify-content: center;

      li {
        width: auto;
        min-width: 70px;
        margin: 0 20px 0 20px;
        font-size: 15px;
        height: 60px;
        line-height: 60px;
        border-radius: 2px;
        text-align: center;
        font-family: Arial-BoldMT;
        font-family: ArialMT;
        padding: 0px 10px;
        color: #474747;
        font-weight: 500;
        cursor: pointer;
      }

      li:hover {
        // color: #000000;
        font-weight: bold;
      }

      .active {
        height: 30px;
        line-height: 30px;
        color: #FFFFFF;
        background: #689BFF;
        border-radius: 20px 20px 20px 20px;
      }
    }

    .right {
      width: 126px;
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .right_icon1 {
        display: flex;
        justify-content: center;
        align-items: center;
        &_img {
          width: 25px;
          height: 60px;
          object-fit: contain;
          cursor: pointer;
        }
      }

      .right_icon2 {
        width: auto;
        height: 36px;
        border-radius: 20px 20px 20px 20px;
        border: 2px solid #000000;

        
        font-weight: normal;
        font-size: 14px;
        color: #000000;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
        
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 0 9px 0 9px;

        &__img {
          width: 24px;
          height: 24px;
          object-fit: contain;
          cursor: pointer;
          margin: 0 5px 0 0;
        }
      }

      .right_icon2:hover {
        border: 2px solid #689BFF;
        color: #689BFF;
      }

      .right_icon3 {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 0 0;
        cursor: pointer;

        &__img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          border-radius: 50%;
        }
        &__text {
          width: 80px;
          
          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          margin: 0 0 0 6px;
        }
      }

      .popoverDialog {
        margin: 65px 0 0 -160px;

        &__text {
          
          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 40px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .el-popover {
          width: 160px;
          height: 170px;
          background: #FFFFFF;
          box-shadow: 0px 14px 16px 0px rgba(0,0,0,0.05);
          border-radius: 8px 8px 8px 8px;
        }
      }
    
    }

    .icon {
      width: 48px;
      height: 60px;

      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-menu {
        width: 36px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
      }
    }
  }
}
</style>
